import { createApp } from 'vue';
import App from './App.vue';
import 'animate.css';
import 'aos/dist/aos.css';
import AOS from 'aos';
import './assets/main.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import router from './router';
import store from './store/store';


const app = createApp(App);

app.use(store);

// Inicializar AOS
app.mixin({
  mounted() {
    AOS.init({
      duration: 1000,
      once: false,
    });
  },
  updated() {
    AOS.refresh();
  }
});

app.use(router);


app.mount('#app');
